import React, { useState } from 'react';
import { NavLink, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ConfirmDialog from './ConfirmDialog';
import './AdminLayout.css';

function AdminLayout() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [confirmLogout, setConfirmLogout] = useState(false);

  const handleLogout = () => {
    setConfirmLogout(true);
  };

  const onConfirmLogout = () => {
    logout();
    navigate('/admin/login');
    setConfirmLogout(false);
  };

  return (
    <div className="admin-layout">
      {/* Overlay untuk mobile - minta buka di desktop */}
      <div className="admin-mobile-overlay">
        <div className="admin-mobile-message">
          <i className="bi bi-display"></i>
          <h3>Admin Panel</h3>
          <p>Panel admin tidak bisa digunakan di handphone.</p>
          <p className="mb-0">Harap buka di <strong>desktop</strong> atau layar yang lebih lebar.</p>
        </div>
      </div>

      {/* Sidebar - fixed, tidak ikut scroll */}
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <div className="sidebar-brand">
            <span className="sidebar-logo brand-icon"><i className="bi bi-briefcase-fill"></i></span>
            <span className="brand-text">EDC Admin</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-people-fill"></i>
            <span>Models</span>
          </NavLink>
          <NavLink
            to="/admin/teams"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-person-badge"></i>
            <span>Team</span>
          </NavLink>
          <NavLink
            to="/admin/contact"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-telephone-plus"></i>
            <span>Contact</span>
          </NavLink>
          <NavLink
            to="/admin/portfolio"
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
          >
            <i className="bi bi-images"></i>
            <span>Portfolio</span>
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <a href="/" target="_blank" rel="noopener noreferrer" className="nav-item">
            <i className="bi bi-box-arrow-up-right"></i>
            <span>View Site</span>
          </a>
          <button type="button" className="nav-item logout-btn" onClick={handleLogout}>
            <i className="bi bi-box-arrow-right"></i>
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-main">
        <Outlet />
      </main>

      <ConfirmDialog
        show={confirmLogout}
        onHide={() => setConfirmLogout(false)}
        onConfirm={onConfirmLogout}
        title="Confirm Logout"
        message="Are you sure you want to logout from admin panel?"
        variant="warning"
      />
    </div>
  );
}

export default AdminLayout;
